<style lang="scss" scoped>
  .box-info{
    font-size: 14px;
    color: #333333;
    height: 650px;
    overflow-y: auto;
    li{
  
      margin-top: 12px;
      /*margin-right: 20px;*/
      overflow: hidden;
      cursor: pointer;
      :hover{
        color: #2342ff;
      }
      b{
        position: relative;
       float: left;
        // width: 5px;
        // height: 5px;
        
        border-radius: 50%;
      
        vertical-align: middle;
        margin-right: 5px;
      }
      .title{
        float: left;
      }
      .time{
        float: right;
      }
    }
  }
</style>
<template>
  <div class="box-info">
<!--咨询组件-->
    <ul v-if="data.length">
      <li @click="go(item)" v-for="(item,i) in data" :key="i">
        <b :style="{color: color}">•</b>
        <span class="title">{{item.infoTitle}} <i v-if="item.infoHlFl*1 === 1" style="color: red">NEW!</i>  </span>
        <span :style="{color: color}" class="time">{{item.infoDt|format}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    props: {
      data: {
        type: Array,
        required: true
      },
      color: {
        type: String
      }
    },
    filters: {
      format(t){
        return new Date(t).Format('yyyy.MM.dd')
      }
    },
    methods: {
      go(item){
        // const
        const url = location.origin + '/webpc/view/' + this.$route.params.cid +"/"+ item.infoId
        window.open(url)
        // location.href = url
      }
    },
    computed: {},
    mounted() {
   
    }
  }
</script>




// WEBPACK FOOTER //
// consultation.vue?0c7043c6